import React from 'react';
import { Users, BarChart2, MessageSquare } from 'lucide-react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';

interface AdminMobileNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export const AdminMobileNav: React.FC<AdminMobileNavProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'users', label: 'Users', icon: Users },
    { id: 'metrics', label: 'Metrics', icon: BarChart2 },
    { id: 'communications', label: 'Logs', icon: MessageSquare }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 lg:hidden">
      <div className="flex justify-around items-center h-16">
        {tabs.map((tab) => (
          <motion.button
            key={tab.id}
            whileTap={{ scale: 0.95 }}
            onClick={() => onTabChange(tab.id)}
            className={clsx(
              'flex flex-col items-center justify-center w-full h-full',
              activeTab === tab.id
                ? 'text-emerald-600'
                : 'text-gray-500 hover:text-gray-900'
            )}
          >
            <tab.icon className="w-5 h-5 mb-1" />
            <span className="text-xs font-medium">{tab.label}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
};